module.exports = __webpack_public_path__ + "static/FuturaStd-Bold-2622261d56c714ff468d9c5abe652b8f.woff2";